module.exports = __webpack_public_path__ + "img/chat.4bd75da4.svg";